import axios from 'axios';
import config from '@/config/env-constants';

export default {

    getAssetPoolDistributions(filterBy, view, currUserId) {
        const url = `${config.cloudFunctionsBaseUrl}/getAssetPoolDistributions`;
        return axios.post(url, {
            view: view,
            currUserId: currUserId,
            filterBy: JSON.stringify(filterBy)
        });
    }
}